// sessions/columns/renderers.js
import MDBox from "components/MDBox";
import { Tag, Tooltip } from "antd";
import { AutoTooltip } from "utils/Constant";

export const StatusCell = (statusColorMap) => ({ row }) => {
    const status = row.original.status;

    return (
        <MDBox display="flex" justifyContent="center">
            <Tag color={statusColorMap[status] || "yellow"}>
                {status}
            </Tag>
        </MDBox>
    );
};

export const EllipsisLinkCell = ({ onClick }) => ({ cell, row }) => {
    const value = cell.getValue() || "N/A";

    return (
        <Tooltip title={value.length > 15 ? value : ""}>
            <span
                onClick={() => onClick(row.original)}
                style={{
                    color: "#1E88E5",
                    cursor: "pointer",
                    textDecoration: "underline",
                    maxWidth: 200,
                    display: "inline-block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}
            >
                {value}
            </span>
        </Tooltip>
    );
};

export const LocationCell = () => ({ cell }) => (
    <AutoTooltip maxWidth={150}>
        <span
            style={{
                display: "inline-block",
                maxWidth: 190,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            }}
        >
            {cell.getValue() || "N/A"}
        </span>
    </AutoTooltip>
);
